import axios from "@/axios.js";

export async function request(method, route, value = {}) {
  try {
    const response = await axios({
      method,
      url: route,
      data: value, 
    });

    return response.data.data ? response.data.data : response.data;
  } catch (error) {
    return { error };
  }
}
